export { type GraphemeStrokeData, graphemeStrokeDataTable } from "#grapheme-stroke-data-table";
